<template>
  <el-card class="w-100 center">
    <div slot="header" class="cf">
      <span class="f5 fw6">Reset password</span>
      <router-link :to="{ name: 'login' }" class="fr f6 link blue hover-hot-pink">Login</router-link>
    </div>

    <NewPasswordForm v-if="!token"></NewPasswordForm>
    <EditPasswordForm v-if="token"></EditPasswordForm>
  </el-card>
</template>

<script>

import NewPasswordForm from 'views/auth/password-form-new.vue'
import EditPasswordForm from 'views/auth/password-form-edit.vue'

export default {
  data() {
    return {
      token: this.$route.query.token
    }
  },

  watch: {
    '$route.query'(query) {
      this.token = query.token;
    }
  },

  components: {
    NewPasswordForm,
    EditPasswordForm
  }

}
</script>

<style scoped>
  
</style>